import { render, staticRenderFns } from "./ModalAdicionarNormativo.vue?vue&type=template&id=fa98a7f2"
import script from "./ModalAdicionarNormativo.vue?vue&type=script&lang=ts"
export * from "./ModalAdicionarNormativo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports